import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <SEO title="Page Not Found" description="The page you are looking for does not exist on YOCILAB." />
      <div className="container">
        <div className="not-found-content">
          <span className="not-found-code">404</span>
          <h1 className="not-found-title">Page Not Found</h1>
          <p className="not-found-desc">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <div className="not-found-actions">
            <Link to="/" className="btn btn-primary">
              Return to Home
            </Link>
            <Link to="/youth-summit" className="btn btn-accent">
              Youth Summit 2026
            </Link>
            <Link to="/programs/yocilab-academy" className="btn btn-outline">
              YOCILAB Academy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;